import styled from 'styled-components';

import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';

export const StyledContainer = styled(Container)`
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 400;
    font-style: normal;
    text-rendering: optimizeLegibility;
    padding-left: 0;
    padding-right: 0;
    height: 100vh;
    background: #f6f6f6;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const StyledRow = styled(Row)`
    margin: 0;
    padding: 1rem;
    padding-top: 0;
    flex: 1 1 auto;
    flex-wrap: nowrap;
    justify-content: space-between;
    overflow: hidden;
`;
